import { getColumnOrderBy } from "../base/getColumnOrderBy.js";
const collectOrderBy = (columns, directionStore, environment) => {
  return Object.entries(directionStore).flatMap(([key, direction]) => {
    const orderBy = getColumnOrderBy(columns, key, direction, environment);
    return orderBy ?? [];
  });
};
export {
  collectOrderBy
};
//# sourceMappingURL=collectOrderBy.js.map
